import { render } from "./ShareErrorComponent.vue?vue&type=template&id=75e1c6d4&scoped=true"
import script from "./ShareErrorComponent.vue?vue&type=script&lang=js"
export * from "./ShareErrorComponent.vue?vue&type=script&lang=js"

import "./ShareErrorComponent.vue?vue&type=style&index=0&id=75e1c6d4&lang=scss&scoped=true"
import "./ShareErrorComponent.vue?vue&type=style&index=1&id=75e1c6d4&lang=scss"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e1c6d4"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QTable,QTr,QTd});
